/**
 * Automatic Persisted Queries (APQ) module
 *
 * This module provides utilities for enabling APQ in Apollo Client.
 * APQ reduces network bandwidth and improves caching by sending query hashes
 * instead of full query strings after the initial request.
 *
 * @see {@link https://www.apollographql.com/docs/apollo-server/performance/apq/}
 */

export { createPersistedQueryLink } from './persisted-query-link';
export type { PersistedQueryLinkOptions } from './persisted-query-link';
